import { Component, Inject, Input, OnInit } from '@angular/core';
import { faCaretUp, faCaretDown, faCircle } from '@fortawesome/free-solid-svg-icons';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { WINDOW } from 'src/app/core/http/window.providers';
import { SharedBestMovementService } from './shared-best-movement.service';

@Component({
    selector: 'app-shared-best-movement',
    templateUrl: './shared-best-movement.component.html',
    styleUrls: ['./shared-best-movement.component.scss'],
})
export class SharedBestMovementComponent implements OnInit {
    @Input() departmentType;

    movements: any;
    desktopVersion;
    constructor(
        private sharedBestMovementService: SharedBestMovementService,
        @Inject(WINDOW) private window: Window,
        private config: NgbCarouselConfig
    ) {
        this.desktopVersion = this.window.innerWidth > 992;
        this.config.showNavigationIndicators = false;
    }

    ngOnInit(): void {
        if (this.departmentType)
            this.sharedBestMovementService
                .getBestMovements(this.departmentType)
                .subscribe((data) => (this.movements = data));
    }

    /**
     * Retorna o icone de acordo com o movimento
     * no ranking.
     * @params mudanca: < 0 | 0 | > 0
     */
    getIconByMove(mudanca) {
        let icon;
        const number = Number(mudanca);

        if (number > 0) {
            icon = faCaretUp;
        } else if (number < 0) {
            icon = faCaretDown;
        } else {
            icon = faCircle;
        }
        return icon;
    }

    /**
     * Retonra cor do icone de ranking de acordo
     * com o movimento do tenista no ranking
     */
    getColorByMove(mudanca) {
        let color;
        const number = Number(mudanca);
        if (number > 0) {
            color = '#4caf50';
        } else if (number < 0) {
            color = '#f44336';
        } else {
            color = '#999';
        }
        return color;
    }
}
